import { zh_CN } from './zh_CN';
import { zh_HK } from './zh_HK';
import { English } from './English';
import { Korea } from './kr';
import { Japan } from './jp';
import { French } from './french';
import { Spanish } from './Spanish';
import { Portuguese } from './portuguese';
import { German } from './German';
import enUS from 'antd/locale/en_US';
import zhCN from 'antd/locale/zh_CN';
import zhHK from 'antd/locale/zh_HK';
import frFR from 'antd/locale/fr_FR';
import esES from 'antd/locale/es_ES';
import deDE from 'antd/locale/de_DE';
import ptPT from 'antd/locale/pt_PT';
import jaJP from 'antd/locale/ja_JP';
import koKR from 'antd/locale/ko_KR';

// antd-mobile 语言包（用于 mobile 端滚轮选择器的确认/取消等文案）
import enUSMobile from 'antd-mobile/es/locales/en-US';
import zhCNMobile from 'antd-mobile/es/locales/zh-CN';
import zhHKMobile from 'antd-mobile/es/locales/zh-HK';
import frFRMobile from 'antd-mobile/es/locales/fr-FR';
import esESMobile from 'antd-mobile/es/locales/es-ES';
import deDEMobile from 'antd-mobile/es/locales/de-DE';
import ptBRMobile from 'antd-mobile/es/locales/pt-BR';
import jaJPMobile from 'antd-mobile/es/locales/ja-JP';
import koKRMobile from 'antd-mobile/es/locales/ko-KR';

function loadLocale(lang) {
    let locale = null;
    let antdLocale = null;
    let mobileLocale = null;
    let message = null;
    switch (lang) {
        case 'en':
            locale = 'en';
            antdLocale = enUS;
            mobileLocale = enUSMobile;
            message = English;
            break;
        case 'cn':
            locale = 'zh-CN';
            antdLocale = zhCN;
            mobileLocale = zhCNMobile;
            message = zh_CN;
                break;
        case 'hk-tc':
        case 'tw':
            locale = 'zh-HK';
            antdLocale = zhHK;
            mobileLocale = zhHKMobile;
            message = zh_HK;
                break;
        case 'jp':
            locale = 'ja';
            antdLocale = jaJP;
            mobileLocale = jaJPMobile;
            message = Japan;
                break;
        case 'kr':
            locale = 'ko';
            antdLocale = koKR;
            mobileLocale = koKRMobile;
            message = Korea;
                break;
        case 'fr':
        case 'ca-fr':
        case 'ch-fr':
            locale = 'fr';
            antdLocale = frFR;
            mobileLocale = frFRMobile;
            message = French;
                break;
        case 'br':
        case 'pt':
            locale = 'pt';
            antdLocale = ptPT;
            mobileLocale = ptBRMobile;
            message = Portuguese;
                break;
        case 'ar':
        case 'bo':
        case 'cl':
        case 'co':
        case 'cr':
        case 'ec':
        case 'sv':
        case 'es':
        case 'gt':
        case 'lac':
        case 'pa':
        case 'mx':
        case 'py':
        case 'pe':
        case 'pr':
        case 'uy':
            locale = 'es';
            antdLocale = esES;
            mobileLocale = esESMobile;
            message = Spanish;
                break;
        case 'ch-gr':
        case 'de':
        case 'at':
            locale = 'de';
            antdLocale = deDE;
            mobileLocale = deDEMobile;
            message = German;
                break;
        default:
            locale = 'en';
            antdLocale = enUS;
            mobileLocale = enUSMobile;
            message = English;
            break;
    }
    return { locale, antdLocale, mobileLocale, message };
}
export { loadLocale };
